import React, {Component} from 'react';
import {capitalizeFirstLetter} from '../../components/helpers/helpers';

class TagsDisplayList extends Component {
    render() {
        const {pageTagsForDisplay, classes} = this.props;

        let TagsList =
            pageTagsForDisplay &&
            Object.values(pageTagsForDisplay).map((value, index) => {
                let tagsKey = Object.entries(pageTagsForDisplay)[index][0];

                // special hack = case for Landing Page, Cancel btn pressed after Done having no tags selected
                if (!isNaN(tagsKey)) {
                    return false;
                }

                let currentTag = pageTagsForDisplay[tagsKey]
                    .map((tag) => tag.term)
                    .join(', ');
                tagsKey = capitalizeFirstLetter(tagsKey.replace(/_/g, ' '));
                let capitalizeKey = tagsKey
                    .split(' ')
                    .map(
                        (word) =>
                            word.substr(0, 1).toUpperCase() +
                            word.substr(1, word.length)
                    )
                    .join(' ');

                return (
                    currentTag.length > 0 && (
                        <ul
                            key={tagsKey}
                            className={classes.contentPageTagsList}
                        >
                            <li>
                                {capitalizeKey}:{' '}
                                {currentTag
                                    .split(capitalizeKey + ' > ')
                                    .join('')}
                            </li>
                        </ul>
                    )
                );
            });

        return <div>{TagsList}</div>;
    }
}

export default TagsDisplayList;



// WEBPACK FOOTER //
// ./src/containers/builder/tags_display_list.js